import type { LandingContent } from "./types";

export const landingZh: LandingContent = {
  locale: "zh",
  seo: {
    title: "Luxoria - 照片与视频 HDR 转换应用",
    description:
      "Luxoria 是一款轻量的照片与视频 HDR 转换应用，帮助你将 SDR 素材转换为更适合 HDR 屏幕观看的输出内容。"
  },
  nav: {
    features: "功能",
    workflow: "流程",
    privacy: "隐私",
    terms: "条款",
    support: "支持",
    language: "English",
    menu: "菜单"
  },
  hero: {
    eyebrow: "SDR 到 HDR，化繁为简",
    title: "将 SDR 照片与视频转换为 HDR。",
    subtitle:
      "Luxoria 是一款轻量的 HDR 转换应用，帮助你将普通 SDR 照片和视频转换为更适合 HDR 屏幕观看的输出内容。",
    tags: ["照片 HDR", "视频 HDR", "批量转换", "本地优先"],
    primaryCta: "在 App Store 下载",
    secondaryCta: "查看功能"
  },
  value: {
    title: "为现代 HDR 屏幕而生。",
    body: "许多照片和视频仍然是 SDR 内容。在支持 HDR 的屏幕上，高光、天空、灯光和明亮场景可能缺少层次。Luxoria 提供简单的转换流程，让普通素材生成更适合 HDR 显示的版本。",
    cards: [
      {
        icon: "sun",
        title: "更有表现力的高光",
        body: "在天空、灯光和明亮场景中恢复细节，适配 HDR 屏幕。"
      },
      {
        icon: "wand",
        title: "更清晰的转换流程",
        body: "清晰流程：选择、转换、查看、保存，毫不杂乱。"
      },
      {
        icon: "layers",
        title: "同时支持照片与视频",
        body: "一个应用搞定 HDR HEIC 照片与 HEVC Main10 HLG 视频。"
      }
    ]
  },
  features: {
    eyebrow: "核心功能",
    title: "Luxoria 能做什么。",
    cards: [
      {
        icon: "image",
        title: "照片 HDR 转换",
        body: "将 SDR 照片转换为带 HDR 元数据的 HEIC 输出，并验证转换结果。",
        bullets: ["单张照片流程", "HDR 预览", "转换强度调节", "HDR HEIC 输出"]
      },
      {
        icon: "copy",
        title: "批量照片转换",
        body: "一次处理多张照片，并展示清晰的进度和结果摘要。",
        bullets: ["多图选择", "进度跟踪", "部分成功结果处理", "可保存输出"]
      },
      {
        icon: "video",
        title: "视频 HDR 转换",
        body: "将 SDR 视频转换为适合 HDR 显示的 HEVC Main10 HLG 输出，并保留音频。",
        bullets: ["视频源分析", "逐帧 HDR 处理", "HEVC Main10 HLG 导出", "结果验证"]
      },
      {
        icon: "share-2",
        title: "保存与分享",
        body: "根据平台将转换结果保存到照片、文件或指定文件夹。",
        bullets: ["保存到照片", "导出到文件", "分享结果", "macOS 显示到 Finder"]
      }
    ]
  },
  workflow: {
    title: "清晰直接的 HDR 转换流程。",
    steps: [
      {
        num: "01",
        icon: "images",
        title: "选择素材",
        body: "选择单张照片、多张照片或一个视频。"
      },
      {
        num: "02",
        icon: "wand",
        title: "转换为 HDR",
        body: "Luxoria 使用面向 HDR 的处理流程分析并转换素材。"
      },
      {
        num: "03",
        icon: "save",
        title: "保存结果",
        body: "将转换后的照片或视频保存到照片、文件或 Mac。"
      }
    ]
  },
  gallery: {
    title: "专注清晰的转换体验。",
    body: "Luxoria 保持主流程简单：选择素材、转换、查看结果、保存输出。",
    shots: [
      { label: "首页", image: "/images/app-store/screen-1.png" },
      { label: "照片 HDR", image: "/images/app-store/screen-2.png" },
      { label: "批量照片", image: "/images/app-store/screen-3.png" },
      { label: "视频 HDR", image: "/images/app-store/screen-4.png" }
    ]
  },
  privacy: {
    title: "我们非常重视你的隐私。",
    body: "隐私是 Luxoria 始终看重的事。转换都在你的设备上完成，你选择的照片和视频只用于生成转换结果，过程中产生的临时文件会在用完后清理。",
    tags: ["本地处理", "临时文件自动清理", "仅处理你选择的素材"],
    linkText: "查看隐私政策"
  },
  footer: {
    tagline: "一款轻量的照片与视频 HDR 转换应用。",
    productBy: "Axqora 旗下产品。",
    productHeading: "产品",
    featuresLabel: "功能",
    workflowLabel: "流程",
    supportLabel: "支持",
    legalHeading: "法律",
    privacy: "隐私政策",
    terms: "用户协议",
    contactHeading: "联系我们",
    rights: "© 2026 Axqora. 保留所有权利。",
    icp: "粤ICP备2021054614号",
    icpHref: "https://beian.miit.gov.cn/"
  }
};
